module.exports = __webpack_public_path__ + "img/4254abb.jpg";